import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const STORAGE_KEY = 'udhs-privacy-preferences-v1'
const OPEN_EVENT = 'udhs:open-privacy-settings'

type Preference = 'accepted' | 'declined'

const readPreference = (): Preference | null => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY)
    return value === 'accepted' || value === 'declined' ? value : null
  } catch {
    return null
  }
}

export const openPrivacySettings = () => window.dispatchEvent(new Event(OPEN_EVENT))

export default function PrivacyPreferences() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(readPreference() === null)
    const reopen = () => setOpen(true)
    window.addEventListener(OPEN_EVENT, reopen)
    return () => window.removeEventListener(OPEN_EVENT, reopen)
  }, [])

  const save = (preference: Preference) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, preference)
    } catch {
      // Preferences remain usable for this visit when persistent storage is unavailable.
    }
    setOpen(false)
  }

  if (!open) return null

  return (
    <aside className="privacy-banner" aria-label="Privacy and storage preferences">
      <div>
        <strong>Privacy choices</strong>
        <p>We use essential browser storage to keep the site working reliably. Optional analytics, if enabled in the future, are only used with your preference.</p>
      </div>
      <div className="privacy-banner__actions">
        <button className="button button--gold" type="button" onClick={() => save('accepted')}>Accept</button>
        <button className="button button--outline" type="button" onClick={() => save('declined')}>Decline optional</button>
        <Link to="/privacy" onClick={() => setOpen(false)}>Privacy</Link>
      </div>
    </aside>
  )
}
